import Api from '../../plugins/Api';
const TokenSuperSeguro = 'Bearer 1e5a475b7421c20cf0edb60543b20d406a2e55fd2619f5f04ee10dbdc41a007b';

export default {
    namespaced: true,
    state: {
        status: null,
        isLogged: false,
        user: {
            ramal: '',
            filas: [],
            senha: '',
            modo: '',
            fullname: '',
            nome: '',
            max_chat_atende: 0,
            edita_rota: false,
            visualiza_todos_clientes: false,
            contexto: '',
            ramal_numero: '',
            status: null,
            oldStatus: null,
            pausa: 0,
            motivoPausa: null
        },
        error: null,
        filas: [],
        filaUnica: false,
        token: localStorage.getItem('token') || ''
    },
    mutations: {
        queueAdd(state, data) {
            let dados = {};
            dados.membername = data.user.fullname;
            dados.location = data.user.ramal;
            dados.queue = data.data.fila;
            dados.queue_type = data.data.queue_type;
            dados.pausado = state.user.pausa === 1 ? true : false;
            dados.action = 'QueueAdd'
            console.log(`dados`, dados);
            this._vm.$Xcontact.sendMessage(dados);
        },
        setError(state, error) {
            if (error.response) {
                state.error = error.response.data.msg
            } else {
                state.error = 'Erro de conexão com o servidor, verifique o endereço do xcontact!'
            }

            console.log(state.error)
        },
        setLocalStorage(state) {
            if (localStorage.getItem('user')) {
                localStorage.removeItem('user');
            }
            localStorage.setItem('user', JSON.stringify(state.user));
        },
        getLocalStorage(state) {
            if (localStorage.getItem('user')) {
                let user = localStorage.getItem('user');
                if (!state.user.filas.length > 0) {
                    state.user = JSON.parse(user);
                    let aux = {
                        action: 'QueueStatus'
                    }
                    this._vm.$Xcontact.sendMessage(aux);
                }

            }
            if (localStorage.getItem('token')) {
                state.token = localStorage.getItem('token');
            }
        },
        auth_request(state) {
            state.status = 'loading'
            state.user.fullname = null;
        },
        setIsLogged(state, data) {
            state.isLogged = data;
        },
        auth_success(state, data) {
            state.status = 'success'
            state.user = data.user
            state.user.status = 0;
            if (state.user.filas.length > 0) {
                for (let fila of state.user.filas) {
                    fila.value = false;
                    fila.pausa = false;
                    fila.motivo = null;

                }
            }
        },
        XC_deslogarAgente(state, agente) {
            state.isLogged = false;
        },
        XC_AgenteStatus(state, data) {
            console.log(`Agente`, data);
            if (state.user.ramal == data.agente.ramal) {
                state.user.oldStatus = JSON.parse(JSON.stringify(state.user.status));
                state.oldStatus = JSON.parse(JSON.stringify(state.status));
                state.user.status = data.agente.status;
                state.status = data.agente.StatusNome;
                console.log(state.oldStatus);
                console.log(state.user.oldStatus);

            }
        },
        XC_FilasStatus(state, data) {
            try {
                //Bora verificar se tem o agente no evento
                data.filas.map(f => {
                    f.fila = f.nome;
                    f.agente = f.agentes.find(a => state.user.ramal === a.ramal);
                });
                for (let fila of data.filas) {
                    if (fila.agente) {
                        console.log(`status do agente`, fila.agente);
                        //bora setar o status do agente no user
                        state.user.status = fila.agente.status;
                        state.status = fila.agente.StatusNome;
                        //Bora ver se existe esta fila no state
                        let filaAux = state.user.filas.find(f => f.fila === fila.nome);
                        if (filaAux) {
                            //#region caso o agente esteja disponivel
                            if (fila.agente.status === 1) {
                                //Caso seja fila unica vamos setar
                                if (state.user.modo !== `F`) {
                                    state.filaUnica = true;
                                    return;
                                }
                                //Senao setamos o vaue na fila
                                filaAux.value = true;
                            } else  //#region Agente em pausa
                                if (fila.agente.status === 10) {
                                    //Caso seja fila unica vamos setar 
                                    if (state.user.modo !== `F`) {
                                        state.filaUnica = true;
                                        state.user.motivoPausa = fila.agente.pausa_motivo;
                                        state.status = `${fila.agente.pausa_motivo}`;
                                        return;
                                    }
                                    //caso multi fila setamos apenas na fila
                                    filaAux.value = true;
                                    state.user.pausa = 1;
                                    state.user.motivoPausa = fila.agente.pausa_motivo;
                                    state.status = `${fila.agente.pausa_motivo}`;
                                } else {
                                    //Caso seja fila unica vamos setar 
                                    if (state.user.modo !== `F`) {
                                        state.filaUnica = false;
                                        return;
                                    }
                                    //caso multi fila setamos apenas na fila
                                    filaAux.value = false;
                                    state.user.pausa = 1;
                                    state.user.motivoPausa = fila.agente.pausa_motivo;
                                    state.status = `${fila.agente.pausa_motivo}`;
                                }
                            //#endregion


                        }//#endregion



                        state.filas = data.filas;

                    }
                }
            } catch (error) {
                console.error(error);
            }

        },
        XC_FilasStatus1(state, data) {
            //Vamos percorrer as filas do filaStatus e atualizar as filas do agente
            if (data.filas && data.filas.length > 0) {
                for (let fila of data.filas) {
                    fila.fila = fila.nome
                    if (fila.agentes && fila.agentes.length > 0) {
                        let agente = fila.agentes.find(a => state.user.ramal === a.ramal);
                        if (agente) {
                            console.log(`tinha o agente`, fila);
                            state.user.status = agente.status;
                            state.status = agente.StatusNome;
                            if (agente.status) {
                                let filaAux = state.user.filas.find(f => f.fila === fila.nome)
                                if (filaAux) {
                                    console.log(`olha a fila ai`, filaAux);
                                    if (agente.status === 1) {
                                        //Caso seja fila unica vamos setar 
                                        if (state.user.modo !== `F`) {
                                            console.log(`era fia unica`)
                                            state.filaUnica = true;
                                            return;
                                        }
                                        //Senao setamos na fila
                                        filaAux.value = true;
                                    }
                                    if (agente.status === 10) {
                                        //Caso seja fila unica vamos setar 
                                        if (state.user.modo !== `F`) {
                                            state.filaUnica = true;
                                            state.user.motivoPausa = agente.pausa_motivo;
                                            state.status = `Pausa ${agente.pausa_motivo}`;
                                            return;
                                        }
                                        //caso multi fila setamos apenas na fila
                                        filaAux.value = true;
                                        state.user.pausa = 1;
                                        state.user.motivoPausa = agente.pausa_motivo;
                                        state.status = `Pausa ${agente.pausa_motivo}`;
                                    }
                                }
                            }
                        }
                    }

                }
                state.filas = data.filas;
            }
        },
        // XC_queueAdd(state, data) {
        //     let index = state.user.filas.findIndex(fila => fila.fila === data.fila);
        //     if (index !== -1) {
        //         console.log(`queueADD`)
        //         //state.user.status = 1;
        //         //.status = "Disponível";
        //         data.value = true;
        //         // state.user.filas.splice(index, 1, data);
        //     }
        // },
        // XC_queueRemove(state, data) {
        //     let index = state.user.filas.findIndex(fila => fila.fila === data.fila);
        //     if (index !== -1) {
        //         data.value = false;
        //         state.user.filas.splice(index, 1, data);
        //         for (let fila of state.user.filas) {
        //             if (fila.value) {
        //                 state.status = "Disponível";
        //                 return;
        //             }
        //         }
        //         state.status = 'Indisponível';
        //     }
        // },
        XC_AgentePausa(state, data) {
            data = data.agente;
            if (state.user.ramal === data.ramal) {
                let filaAux = state.user.filas.find(f => f.fila === data.fila);
                if (filaAux) {
                    //filaAux.value = true;
                    state.user.status = data.status;
                    state.status = data.StatusNome;
                    if (data.pausa === 1) {
                        state.user.motivoPausa = data.pausa_motivo;
                        state.status = `${data.pausa_motivo}`;
                    }

                }
            }
        },
        XC_AgenteRemovido(state, data) {
            data = data.agente;
            if (state.user.ramal === data.ramal) {
                if (state.user.modo !== `F`) {
                    state.filaUnica = false;
                    state.user.status = data.status;
                    state.status = `Indisponível`
                    return;
                }
                let filaAux = state.user.filas.find(f => f.fila === data.fila);
                if (filaAux) {
                    filaAux.value = false;
                    for (let fila of state.user.filas) {
                        if (fila.value) {
                            if (state.user.status !== 10) {
                                state.status = "Disponível";

                            }
                            return;

                        }
                    }
                    state.user.motivoPausa = null;
                    state.user.status = data.status;
                    state.status = 'Indisponível';



                }
            }

        },
        XC_AgenteAdicionado(state, data) {
            data = data.agente;
            if (state.user.ramal === data.ramal) {
                if (state.user.modo !== `F`) {
                    console.log(`agenteadiconado fila unica`)
                    state.filaUnica = true;
                    if (state.user.status !== 10) {
                        state.user.status = data.status;
                        state.status = data.StatusNome
                    }
                    return;
                }
                let filaAux = state.user.filas.find(f => f.fila === data.fila);
                if (filaAux) {
                    if (state.user.status !== 10) {
                        state.user.status = data.status;
                        state.status = data.StatusNome
                    }

                    filaAux.value = true;
                }
            }

        },
        XC_queueAdd(state) {
            let user = localStorage.getItem('user');
            if (!state.user.filas.length > 0) {
                state.user = JSON.parse(user);
                let aux = {
                    action: 'QueueStatus'
                }
                this._vm.$Xcontact.sendMessage(aux);
            }
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = ''
        },
        setMotivoPausa(state, data) {
            state.user.status = 10;
            state.user.motivoPausa = data;
        },
        setStatus(state, data) {
            state.status = data;
            state.isLogged = false;
            state.user.fullname = null;
        }
    },


    actions: {
        login({ commit }, credentials) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                let config = JSON.parse(localStorage.getItem("config"))
                console.error('CONFIG', config.servidor);
                console.error('CREDENCIAIS', credentials);
                Api.http.all([
                    Api.http.post(`https://${config.servidor}:8004/api/v2/usuarios/agentes/login`, credentials).then((resp) => {
                        if (resp.data.error) {
                            commit('auth_error')
                            localStorage.removeItem('token')
                            localStorage.removeItem('user_menu')
                            commit(`setIsLogged`, false);
                            reject(resp.data)
                        }
                        else {
                            console.log(resp);
                            //const token = resp.data.user.token
                            const token = TokenSuperSeguro;
                            const dados = {}
                            dados.user = resp.data
                            dados.token = token;
                            localStorage.setItem('token', token)
                            Api.setToken(token);
                            commit('auth_success', dados)
                            commit('setLocalStorage');
                            commit(`setIsLogged`, true);
                            resolve(resp)
                        }
                    }).catch(err => {
                        console.log(err);
                        commit('auth_error');
                        commit('setError', err)
                        commit(`setIsLogged`, false);
                        localStorage.removeItem('token')
                        reject(err)
                    })
                ])
            })
        },
        logout({ commit }) {
            return new Promise((resolve) => {
                commit('logout')
                localStorage.removeItem('user_menu')
                localStorage.removeItem('token')
                Api.unsetToken();
                resolve()
            })
        },
        setStatus({ commit }, data) {
            commit(`setStatus`, data);
        },
        queueAdd({ commit }, data) {
            commit(`queueAdd`, data)
        },
        queueRemove({ commit }, data) {
            // commit('XC_queueRemove', data.data);
            console.log(commit);
            let dados = {};
            dados.membername = data.user.fullname;
            dados.location = data.user.ramal;
            dados.queue = data.data.fila;
            dados.queue_type = data.data.queue_type;
            dados.action = 'QueueRemove'
            console.log(`dados`, dados);
            this._vm.$Xcontact.sendMessage(dados);
        },
        queuePause({ commit }, data) {
            commit(`setMotivoPausa`, data.motivo)
            let dados = {};
            dados.location = data.user.ramal;
            dados.motivo = data.motivo;
            dados.action = 'QueuePause'
            this._vm.$Xcontact.sendMessage(dados);

            let aux = {
                action: 'QueueStatus'
            }
            this._vm.$Xcontact.sendMessage(aux);
        },
        queueUnpause({ commit }, data) {
            commit(`setMotivoPausa`, null)
            let dados = {};
            dados.location = data.user.ramal;
            dados.motivo = data.motivo;
            dados.action = 'QueueUnpause'
            this._vm.$Xcontact.sendMessage(dados);
        },
        getLocalStorage({ commit }) {
            commit('getLocalStorage');
        },
        setLocalStorage({ commit }) {
            commit('setLocalStorage');
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
    }

}